<template>
<div>
	<div class="col-sm-3 no-print" >
		
		<div class="row">
			<div class="col-md-12 form-group">
				<label>* {{_traducao('componentNatureza','cTipo')}}</label> <br/>
				
				<p v-show="controle.loadTipo">
					<flCarregando />
				</p>
				
				<select v-show="!controle.loadTipo" 
							@change="setaTipo" 
							class="form-control input-sm" 
							v-model="tipo">
					<option v-for="item in tipos" :value="item.id" :key="item.id" >{{item.descricao}}</option>
				</select>
			</div>
		</div>
		
		<div class="row form-group">
			<div class="col-md-12" v-show="controle.natureza">
				<label>* {{_traducao('componentNatureza','cNatureza')}}</label>  <br />
				
				<p v-show="controle.loadNatureza">
					<flCarregando />
				</p>

				<select v-show="!controle.loadNatureza" 
						class="form-control input-sm" 
						v-model="natureza">
					<option v-for="item in naturezas" :value="item.id" :key="item.id" >{{item.descricao}}</option>
				</select>
			</div>
		</div>


		<div class="row">
			<div class="col-md-12">
				<button  	@click="doAddItemNatureza"
							class="btn btn-primary btn-sm btn-block">
					<i class="fa fa-plus"></i> {{_traducao('global','criar')}}
				</button>
			</div>
		</div>
	</div>
	
	<div class="col-sm-9 col-xs-12">
		<table class="table table-bordered table-hover table-condensed margin-print-0" style="margin-top:26px">
			<thead>
				<tr>
					<th class="text-center" style="width:45%">{{_traducao('componentNatureza','cTipo')}}</th>
					<th class="text-center" style="width:45%">{{_traducao('componentNatureza','cNatureza')}}</th>
					<th class="text-center no-print" style="width:10%"></th>
				</tr>
			</thead>
			<tbody>
				<tr class="text-center" v-for="(item, index) in selecionados" :key="index">
					<td>{{item.tipo.descricao}}</td>
					<td>{{item.natureza.descricao}}</td>
					<td class="no-print">
						<button type="button" 
								@click.prevent="doRemoveItemNatureza(index)"
								class="btn btn-danger btn-xs btn-block">
							<i class="fa fa-trash fa-fw"></i>{{_traducao('global','excluir')}}
						</button>
					</td>
				</tr>
				<tr class="text-center" v-show="selecionados.length == 0">
					<td colspan="3"> {{_traducao('componentNatureza','cItem')}} </td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
</template>

<script>

    export default {

        props: {
        	unico: {
        		type: Boolean,
        		required: false,
        		default: false,
        	}
        },

        data: function () {
            return {

                naturezas: [],
                tipos: [],
                natureza: "",
                tipo: "",

                controle: {
                	natureza: false,
                	loadTipo: false,
                	loadNatureza: false,
                },

                selecionados: [],
            }
        },

        mounted: function(){
			this.eventos()
        	this.getTipos();
        },

        methods:{

        	eventos: function(){
        		var self = this
	        	bus.$on('limpa-lista-tipo-natureza', function(){
	        		self.limpaCampos();
	        	})

	        	bus.$on('natureza-tipo-carrega-lista', function(lista){
	        		self.limpaCampos();

	        		for(var i in lista){
	        			var auxNatureza = {
	        				id: lista[i].id_natureza,
	        				descricao: lista[i].natureza
	        			}
	        			var auxTipo = {
	        				id: lista[i].id_tipo,
	        				descricao: lista[i].tipo
	        			}

		        		self.selecionados.push({ natureza: auxNatureza, tipo: auxTipo });
	        		}

	        		bus.$emit('natureza-tipo-selecionado', self.selecionados)
	        	})
        	},

        	limpaCampos: function(){
        		this.selecionados = []
        		this.natureza = ""
        		this.tipo = ""
        		this.controle.tipo = false
        	},

        	// REMOVE UM ITEM NA LISTA DE NATUREZA
        	doRemoveItemNatureza: function(index){

        		var item = this.selecionados[index];

        		//if(item.natureza.id == 12 && item.tipo.id == 99){
        		//	this.controle.orgaoApoiado = false;
        		//}

        		this.selecionados.splice(index, 1);
        		bus.$emit('natureza-tipo-selecionado', this.selecionados)
        	},

        	// ADD UM ITEM NA LISTA DE NATUREZA DA OPERACAO
        	doAddItemNatureza: function(){
        		var add = true;

        		// cidade e estado selecionado
        		if(this.natureza != "" && this.tipo != ""){

        			var add = true
        			if(this.selecionados.length > 0){

        				if(this.unico == true){

        					bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('componentNatureza','cAddItem')})

							return false;
        				} else{
		        			for(var i in this.selecionados){

		        				if(this.selecionados[i].natureza.id == this.natureza &&
		        					this.selecionados[i].tipo.id == this.tipo){
		        					add = false;
		        					bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('componentNatureza','cItemAdicionado')})
		        					break;
		        				}
		        			}
        				}
        			}

        			// se não tiver add
        			if(add == true){
	        			var auxNatureza = []
	        			for(var i in this.naturezas){
	        				if(this.naturezas[i].id == this.natureza){
	        					auxNatureza = this.naturezas[i]
	        					break
	        				}
	        			}

	        			var auxTipo = []
	        			for(var i in this.tipos){
	        				if(this.tipos[i].id == this.tipo){
	        					auxTipo = this.tipos[i]
	        					break
	        				}
	        			}

	        			this.selecionados.push({ natureza: auxNatureza, tipo: auxTipo });
	        			bus.$emit('natureza-tipo-selecionado', this.selecionados)
        			}

        		} else {

        			bus.$emit('exibir-notificacao', {type: 'info', text: this._traducao('menuSolicitaApoio','naturezaEtipo')})
        		}
        	},

        	// SETA A NATUREZA E CARREGA O TIPO DA NATUREZA
        	setaTipo: function(){

				//////console.log(this.natureza)
				////console.log(this.tipo)

				if(this.tipo != ""){
					
					this.natureza = ""
					var self = this;
					this._httpGet('ibama/Solicitacao/get_natureza_by_id_tipo/' + this.tipo, function(retorno){
						if(retorno._request && retorno._status){
							retorno.lista.unshift({id: "", descricao: self._traducao('global','escolha').toUpperCase()})
							self.naturezas = retorno.lista
							self.controle.loadNatureza = false;
							self.controle.natureza = true
						}
					})
				}
        	},

        	// PEGA OS TIPOS DE MISSAO NO WS
        	getTipos: function(){
        		
				var self = this;
				this._httpGet('ibama/Solicitacao/get_tipo_natureza', function(retorno){
					if(retorno._request && retorno._status){
						retorno.lista.unshift({id:"", descricao: self._traducao('global','escolha').toUpperCase()})
						self.tipos = retorno.lista;
					}
				})
        	},
        }
    }
</script>
